
const digest = '054b2bdc4291a02f0fedb1ff2e9f1db0dd2db76d7766c9444c31a9269cfda2b4';
const classes = {"wrapper":"_wrapper_12qqc_1","title":"_title_12qqc_9","button":"_button_12qqc_13","circle1":"_circle1_12qqc_21","circle2":"_circle2_12qqc_30"};
const css = `._wrapper_12qqc_1 {
  display: flex;
  flex-direction: column;
  gap: 30px;
  align-items: center;
  text-align: center;
  padding: 30px;
}
._wrapper_12qqc_1 ._title_12qqc_9 {
  font-size: 22px;
  font-weight: 600;
}
._wrapper_12qqc_1 ._button_12qqc_13 {
  font-weight: 600;
  background: linear-gradient(135deg, #1e6ce3 0%, #0054bc 100%);
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow);
  width: 100%;
}
._wrapper_12qqc_1 ._circle1_12qqc_21 {
  background-color: #ffe8e6;
  border-radius: 100%;
  height: 100px;
  width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}
._wrapper_12qqc_1 ._circle1_12qqc_21 ._circle2_12qqc_30 {
  background-color: #ffdad6;
  border-radius: 100%;
  height: 65px;
  width: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
}
._wrapper_12qqc_1 ._circle1_12qqc_21 ._circle2_12qqc_30 img {
  height: 35px;
  width: 35px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  